// extracted by mini-css-extract-plugin
export default {"Logo":"logo_Logo__M4ZgF","picture":"logo_picture__0peSp"};